// extracted by mini-css-extract-plugin
export default {"main-container":"App_main-container__EPIb1"};